/* ==========================================================================
   STICKR LAB - CUSTOM DIE-CUT STICKERS  ·  diecut.js
   The ONLY JavaScript this page needs. ~1.2 KB, no dependencies.

   It does exactly two things:
     1. Scroll reveal - adds .is-in to reveal targets once, on entry, with a
        scroll/resize fallback and a 2s hard timeout so content can NEVER
        stay invisible if IntersectionObserver fails to fire.
     2. Cutline length - measures the signature SVG path so its draw-on
        animation is exact at any size.

   NOT required for: the FAQ accordion (native <details>/<summary>), any
   hover state, or any layout. The page is fully readable and usable with
   JavaScript disabled - reveals simply start visible.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.sl-dc');
  if (!root) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- 1. measure the cutline path so stroke-dashoffset starts exactly at its length
  var trace = null;

  // --- 2. reveal on scroll (once per element)
  var targets = root.querySelectorAll('.sl-dc-rev, .sl-dc-cut');

  function showAll() {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
    if (trace) trace.style.strokeDashoffset = 0;
  }

  if (reduced || !('IntersectionObserver' in window)) { showAll(); return; }

  var ioFired = false;

  function reveal(el) {
    el.classList.add('is-in');
    if (trace && el.classList.contains('sl-dc-cut')) trace.style.strokeDashoffset = 0;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      ioFired = true;
      reveal(entry.target);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  for (var i = 0; i < targets.length; i++) io.observe(targets[i]);

  /* Fallback. IntersectionObserver can silently fail to fire in embedded or
     non-scrolling contexts (previews, some in-app browsers). Content must
     never stay invisible, so we also reveal on scroll, and if the observer
     has produced nothing at all after 2s we assume it is broken and show
     everything. The check is conditional so it does not pre-empt the normal
     scroll animation on a healthy page. */
  function sweep() {
    var pending = false;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (t.classList.contains('is-in')) continue;
      if (t.getBoundingClientRect().top < window.innerHeight * 0.92) { reveal(t); io.unobserve(t); }
      else pending = true;
    }
    if (!pending) window.removeEventListener('scroll', sweep);
  }
  window.addEventListener('scroll', sweep, { passive: true });

  setTimeout(function () {
    if (!ioFired && !root.querySelector('.sl-dc-rev.is-in')) showAll();
    else sweep();
  }, 2000);
})();
